import { render, staticRenderFns } from "./customization.vue?vue&type=template&id=d247d718&scoped=true&"
import script from "./customization.vue?vue&type=script&lang=js&"
export * from "./customization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d247d718",
  null
  
)

export default component.exports